import { Link } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { images } from "../assets/assets";
import { Check, Files, MoveRight, Phone } from "lucide-react";
import Footer from "../Components/Footer";
import { useEffect } from "react";

const Ayushman = () => {
  const AyushmanDetail = {
    image: images.AyushmanLogo,
    overview: [
      "Ayushman Bharat Yojana, also known as Pradhan Mantri Jan Arogya Yojana (PM-JAY), is a flagship government healthcare scheme aimed at providing financial protection and free medical treatment to economically weaker sections of society. The scheme was launched to ensure that quality healthcare services are accessible to all, especially those who cannot afford expensive treatments. It offers health coverage of up to ₹5 lakh per family per year for secondary and tertiary care hospitalization.",
      "Ayushman Bharat focuses on reducing the financial burden of medical expenses and improving overall healthcare accessibility across the country. The scheme covers a wide range of treatments including surgeries, diagnostics, and hospitalization costs. Beneficiaries can avail cashless treatment at empaneled hospitals across India.",
      "It is designed to support millions of families by providing timely medical care without financial stress. The scheme also promotes early diagnosis and preventive healthcare, helping improve long-term health outcomes. Overall, Ayushman Bharat plays a vital role in strengthening the healthcare system and ensuring affordable treatment for all.",
    ],
    benefits: [
      "₹5 Lakh coverage per family per year",
      "Cashless and paperless treatment",
      "Wide range of treatments covered",
      "Pre and post-hospitalization expenses covered",
      "No restrictions on family size, age or gender",
      "Coverage across India at empanelled hospitals",
    ],
    requirement: [
      "Ayushman Bharat Card (if available)",
      "Aadhaar Card (mandatory)",
      "Registered mobile number",
      "Any other government-issued ID proof",
    ],
    eligibility: [
      "Families living in kutcha houses",
      "Families with no adult member aged 16-59",
      "Female headed households",
      "Families with disabled members",
      "SC/ST households",
      "Landless households doing manual casual labor",
    ],
    treatments: [
      "Medical and surgical treatments",
      "Pre-existing conditions coverage",
      "Day care procedures",
      "Diagnostic services",
      "Medicines and consumables",
      "Accommodation charges",
      "Complications arising during treatment",
    ],
  };
  return (
    <div className="font-lato">
      <Navbar />
      <div
        className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
        style={{
          backgroundImage: `linear-gradient(#00000099, #00000099), url(${images.AyushmanBanner})`,
        }}
      >
        <div className="flex flex-col sm:flex-row justify-center sm:justify-start gap-2 sm:gap-4 items-center max-w-[1100px]">
          <img
            src={AyushmanDetail.image}
            alt="logo"
            className="w-[50px] h-[50px] sm:w-[80px] sm:h-[80px] md:w-[95px] md:h-[95px] flex-shrink-0 hover:scale-105 transition-transform duration-300"
          />
          <div className="max-w-[500px] text-white">
            <p className="font-bold text-[16px] sm:text-[20px] md:text-[24px] text-center sm:text-left">
              Ayushman Bharat Yojana
            </p>
            <p className="font-openSans text-[12px] sm:text-[14px] md:text-[16px] leading-[1.2] text-center sm:text-left">
              Dev Rishi Hospital is proud to be associated with this initiative,
              offering quality healthcare services to eligible patients under
              this scheme.
            </p>
          </div>
        </div>
      </div>
      {/* Detail */}
      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-14 max-w-[1170px] mx-auto py-6 md:py-8 px-4">
        <div className="w-full lg:w-[65%]">
          {/* overview */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <p className="text-[16px] sm:text-[18px] font-semibold text-black mb-2 sm:mb-1">
              Overview:
            </p>
            {AyushmanDetail.overview.map((longdescription, idx) => (
              <p
                key={idx}
                className="text-[14px] sm:text-base leading-[1.6] font-openSans mb-1"
              >
                {longdescription}
              </p>
            ))}
          </div>
          {/* experties */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Key Benefits
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2 mt-3">
              {AyushmanDetail.benefits.map((benefit, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                >
                  <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                  <p className="text-black font-openSans text-[13px] sm:text-base">
                    {benefit}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* Eligibility */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Who is Eligible?
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-2 mt-3">
              {AyushmanDetail.eligibility.map((eligible, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                >
                  <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                  <p className="text-black font-openSans text-[13px] sm:text-base">
                    {eligible}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* Treatments */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Covered Treatments:
              </p>
            </div>
            <p className="text-black font-openSans text-[13px] sm:text-base mb-2">
              Over 1,500 medical procedures are covered under the scheme
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-2 mt-3">
              {AyushmanDetail.treatments.map((treatment, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start hover:translate-x-1 transition-transform duration-200 cursor-pointer"
                >
                  <span className="w-[6px] h-[6px] sm:w-[8px] sm:h-[8px] rounded-full bg-[#D9D9D9] mt-2 flex-shrink-0"></span>
                  <p className="text-black font-openSans text-[13px] sm:text-base">
                    {treatment}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* doctor detail */}
        <div className="w-full lg:w-auto lg:flex-1">
          <div
            className="h-[280px] sm:h-[320px] md:h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-all duration-500 hover:shadow-xl hover:-translate-y-1 rounded-[10px] overflow-hidden cursor-pointer"
            style={{
              backgroundImage: `url(${images.AyushmanPhoto})`,
            }}
          ></div>
          <div className="grid grid-cols-1 sm:justify-items-center gap-2 mt-3 sm:mt-2">
            <Link
              to="/appointment"
              className="bg-[#F59E0B] rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
            >
              Apply for Ayushman Card{" "}
              <span className="p-2.5 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
                <MoveRight
                  color="#000"
                  className="rotate-[-38deg] w-3.5 h-3.5 sm:w-5 sm:h-5"
                />
              </span>
            </Link>
          </div>
          {/* required doc */}
          <div className="border border-[#A4A4A4] rounded-[15px] sm:rounded-[20px] px-4 sm:px-6 py-4 mt-4 sm:mt-6 hover:border-[#1975FF] hover:shadow-md transition-all duration-300">
            <div className="flex items-center gap-2 mb-2 sm:mb-1">
              <Files color="#000" className="w-6 h-6" />
              <p className="text-[16px] sm:text-[18px] font-semibold text-black">
                Required Documents:
              </p>
            </div>
            {AyushmanDetail.requirement.map((require, idx) => (
              <div
                key={idx}
                className="flex gap-2 items-start mt-2 hover:translate-x-1 transition-transform duration-200 cursor-pointer"
              >
                <Check color="#000" className="w-5 h-5 text-black" />
                <p className="text-black font-openSans text-[13px] sm:text-base">
                  {require}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/*  Book Consultation  */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-5 mb-14">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Need Help with Ayushman Bharat?
        </h1>
        <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
          Visit our Ayushman Bharat helpdesk or contact us for assistance
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <a
            href="tel:+917300906444"
            className="border  rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 px-3 sm:px-3 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white bg-[#1975FF] hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-white rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#000" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Helpdesk
          </a>
          <a
            href="#"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            Visit Hospital
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Ayushman;
